// A cell which displays values as numeric values.
// @flow
import React from 'react';
import { FORMATTER_DATA_TYPES, ALIGNMENT_CSS_CLASS } from './constants';
import EmptyCell from './EmptyCell';

export default function(value: number) {
    // 'this' in this context is the column metadata.
    let displayValue = null;

    if (value === null) {
        return <EmptyCell alignment={ALIGNMENT_CSS_CLASS.RIGHT} />;
    }

    if (this.dataType === FORMATTER_DATA_TYPES.INTEGER) {
        displayValue = value.toFixed(0);
    } else if (this.dataType === FORMATTER_DATA_TYPES.FLOAT) {
        displayValue = value.toFixed(1);
    }

    return <div className="cell numeric">{displayValue}</div>;
}



// WEBPACK FOOTER //
// ./src/view/common/table/formatters/NumericCell.jsx